// 業界比較 表示内容保存
export const RESULT_DATA_SET =
  "tools/comparison/industry/result-data/RESULT_DATA_SET";
// 業界比較 表示内容クリア
export const RESULT_DATA_CLEAR =
  "tools/comparison/industry/result-data/RESULT_DATA_CLEAR";
